import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getAnalyticsTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="analytics-page-header"]',
    popover: {
      title: t("tour.analytics.pageHeader.title"),
      description: t("tour.analytics.pageHeader.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="analytics-prebuilt-dashboards"]',
    popover: {
      title: t("tour.analytics.prebuiltDashboards.title"),
      description: t("tour.analytics.prebuiltDashboards.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="analytics-create-dashboard"]',
    popover: {
      title: t("tour.analytics.createDashboard.title"),
      description: t("tour.analytics.createDashboard.description"),
      side: "left",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const analyticsTourConfig = {
  id: "analytics" as const,
  steps: getAnalyticsTourSteps,
};
